import { useContext } from 'react';
import classnames from 'classnames';
import { Icon, MenuButton } from 'components/common';
import { SavedFilterContext } from 'components/filters';

const SavedFilterButton = () => {
  const { buttonTopRef, handleToggle, savedFilterPanelOpen } = useContext(SavedFilterContext);

  return (
    <MenuButton
      active={savedFilterPanelOpen}
      icon={
        <Icon
          className={classnames('saved-filters__icon', {
            'saved-filters__icon--active': savedFilterPanelOpen,
          })}
          name="floppy-disk"
        />
      }
      ref={buttonTopRef}
      onClick={() => handleToggle('topbar')}
      testId="saved-filter-button"
      text="Saved Filters"
    />
  );
};

export default SavedFilterButton;
